import Entities from 'STORE';

export function endQuote(groupId: string | null): void {
  const inputPanel = groupId
    ? Entities.InputPanelsStore.getById(groupId)
    : Entities.InputPanelsStore.activeInputPanel;

  if (inputPanel && inputPanel.quote) {
    inputPanel.setQuote(null);
  }
}
